import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ButtonContainer, Modal, ModalFooter } from '@emburse/embark-core';
import { useEffect, useState } from 'react';
function ConfirmationModal({ show, title, loading, confirmText, cancelText, onClose, isDanger, onConfirm, children }) {
    const [isLoading, setIsLoading] = useState(false);
    const buttonColor = isDanger ? 'error' : 'primary';
    useEffect(() => {
        setIsLoading(loading);
    }, [loading]);
    return (_jsx(Modal, { open: show, modalHeader: title, onClose: () => {
            onClose();
        }, isLoading: isLoading, modalFooter: _jsx(ModalFooter, { children: _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", color: buttonColor, onClick: () => {
                            onClose();
                        }, children: cancelText }), _jsx(Button, { color: buttonColor, onClick: () => {
                            onConfirm();
                        }, children: confirmText })] }) }), children: children }));
}
ConfirmationModal.defaultProps = {
    title: 'Confirmation',
    loading: false,
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    isDanger: false
};
export default ConfirmationModal;
